import scheduleTimeCompleted from "../../../../../../public/images/access-screens/scheduleTimeCompleted.png";
import { useTranslation } from "react-i18next";

const ScheduleTimeCompleted = ({
  orgBasedFeatureName = "assessment"
}: {
  orgBasedFeatureName?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center space-y-5 text-center justify-center w-full py-10">
      <img
        src={scheduleTimeCompleted}
        alt={t("assessment.accessScreens.scheduleTimeCompleted.alt")}
        className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
      />
      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.accessScreens.scheduleTimeCompleted.title", {
            featureName: orgBasedFeatureName
          })}
        </h1>
        <p className="mt-5 text-primary text-base">
          {t("assessment.accessScreens.scheduleTimeCompleted.description", {
            featureName: orgBasedFeatureName
          })}
        </p>
      </div>
    </div>
  );
};

export default ScheduleTimeCompleted;
